// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateCart } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";
import McMcApplicationState from "@mcmc/App/Store/McMcApplicationState";
import { getShipCompleteCheckboxState } from "@mcmc/App/Store/Selectors/CheckoutReviewAndSubmitSelectors";
import { getSettingsCollection } from "@mcmc/App/Store/Selectors/SettingsSelectors";

type HandlerType = Parameters<typeof PopulateCart>[0];

const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");

export const UpdateOverrideShipToAddress = (props: HandlerType) => {
    const state = props.getState() as McMcApplicationState;
    const requestedPickupDate = state.xCustomCheckoutShipping.requestedPickupDate;
    if (typeof requestedPickupDate !== "undefined") {
        props.cart.requestedPickupDate = convertDateToApiFormat(requestedPickupDate);
    }
    props.cart.properties = {
        ...props.cart.properties,
        overrideShipToAddress: JSON.stringify(state.xCustomCheckoutShipping.overrideAddressFormState?.address) || "",
    };
};

export const UpdateIsShipComplete = (props: HandlerType) => {
    const state = props.getState() as McMcApplicationState;
    const settingsCollection = getSettingsCollection(state);
    const shipCompleteState = getShipCompleteCheckboxState(settingsCollection);
    if (!props.cart.properties.isShipComplete) {
        props.cart.properties = {
            ...props.cart.properties,
            isShipComplete: `${shipCompleteState.defaultValue}`,
        };
    }
};

addToChainAfter(chain, PopulateCart, UpdateOverrideShipToAddress);
addToChainAfter(chain, PopulateCart, UpdateIsShipComplete);
